/**
 * Retry-After, parsed once. A refusal says how long to wait in its
 * `Retry-After` header (delta-seconds or an HTTP date) and, from the API's
 * limiter, again in the body's `retryAfter` (seconds). The retry SCHEDULERS
 * (what to do with the wait) stay where they are; this only reads it.
 */

/** A header by case-insensitive name from a plain object or a Headers-like `get`. */
export function headerOf(headers, name) {
	if (!headers) return undefined;
	const lower = String(name).toLowerCase();
	if (typeof headers.get === 'function') {
		const value = headers.get(name);
		if (value !== undefined && value !== null) return value;
	}
	const key = Object.keys(headers).find(entry => entry.toLowerCase() === lower);
	return key === undefined ? undefined : headers[key];
}

/**
 * A `Retry-After` value in milliseconds from now, or null when there is none.
 * Delta-seconds ("30", "1.5") or an HTTP date; a date already past is zero.
 */
export function parseRetryAfter(value, now = Date.now()) {
	if (value === undefined || value === null) return null;
	const text = String(value).trim();
	if (!text) return null;
	if (/^\d+(\.\d+)?$/.test(text)) return Math.round(Number(text) * 1000);
	const at = Date.parse(text);
	if (Number.isNaN(at)) return null;
	return Math.max(0, at - now);
}

/**
 * The wait a refusal asks for, in ms, or null. Header first, then the body's
 * `retryAfter` (seconds) when `body` is true (read `response.data`) or an
 * object (read it). Takes an error with `.response` or a response itself.
 */
export function retryAfterMs(errorOrResponse, { now = Date.now(), body = false } = {}) {
	const response = errorOrResponse?.response ?? errorOrResponse;
	const header = parseRetryAfter(headerOf(response?.headers, 'retry-after'), now);
	if (header !== null) return header;
	if (!body) return null;
	const data = body === true ? response?.data : body;
	if (!data || typeof data !== 'object' || data.retryAfter === undefined || data.retryAfter === null) return null;
	const seconds = Number(data.retryAfter);
	return Number.isFinite(seconds) && seconds >= 0 ? seconds * 1000 : null;
}
